import { app_yeu_cau_ho_tro_group } from '../models/response/app-phuhuynh/app_yeu_cau_ho_tro_group';
import { BaseCRUDApi } from './baseCRUDApi';


export const API_YCHT_GROUP_PATH = "app-yeu-cau-ho-tro-group"

class YeuCauHoTroGroupApi extends BaseCRUDApi<app_yeu_cau_ho_tro_group>{
    constructor(path: string) {
        super(path);
    }
   
}
export const yeuCauHoTroGroupApi = new YeuCauHoTroGroupApi(API_YCHT_GROUP_PATH)
